import { style } from '@vanilla-extract/css';

export const boostContainer = style({
  width: '100%',
  height: 'auto',
  borderCollapse: 'collapse',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: '16px',
  paddingBottom: '16px',
});

export const boostInnerContainer = style({
  padding: '19px',
  background: '#f9fafb',
  borderRadius: '5px',
  border: '1px solid #d1d5db',
  display: 'flex',
  flexDirection: 'column',
});

export const boostContentContainer = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'start',
});

export const content = style({
  color: '#282828',
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'left',
  marginBottom: '20px',
});

export const imageContainer = style({
  flexShrink: 0,
  border: '1px solid #d1d5db',
  borderRadius: '5px',
  verticalAlign: 'top',
  overflow: 'hidden',
  marginRight: '16px',
  marginBottom: '20px',
});

export const image = style({
  minWidth: '75px',
  maxWidth: '75px !important',
  minHeight: '75px',
  objectFit: 'cover',
});

export const button = style({
  cursor: 'pointer',
  background: '#FFFFFF',
  border: '1px solid #d1d5db',
  borderRadius: '4px',
  color: '#282828',
  fontSize: '14px',
  fontWeight: '600',
  padding: '12px',
  lineHeight: 'normal',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const subtitle = style({
  padding: '0',
  color: '#767676',
  fontSize: '14px',
  fontWeight: '400',
  display: 'block',
});

export const sponsored = style({
  padding: '0',
  color: '#BBBBBB',
  fontSize: '12px',
  fontWeight: '700',
  display: 'block',
});
